import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";
import { useState } from "react";
import { EyeIcon, EyeOffIcon } from "../../icons/EyeIcon";

function FormInputFields({ form, onChange }) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      {/* Email */}
      <div className="adminAuth__field">
        <label className="adminAuth__label">{t("adminLogin.fields.email")}</label>
        <input
          className="adminAuth__input"
          type="email"
          name="email"
          value={form.email}
          onChange={onChange}
          required
          autoComplete="username"
          placeholder="Enter your email"
        />
      </div>

      {/* Password */}
      <div className="adminAuth__field">
        <label className="adminAuth__label">{t("adminLogin.fields.password")}</label>

        <div className="adminAuth__inputWrapper">
          <input
            className="adminAuth__input"
            type={showPassword ? "text" : "password"}
            name="password"
            value={form.password}
            onChange={onChange}
            required
            autoComplete="current-password"
            placeholder="Enter your password"
          />

          <button
            type="button"
            className="adminAuth__passwordToggle"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        </div>
      </div>

      {/* Extras */}
      <div className="adminAuth__row">
        <label className="adminAuth__remember">
          <input type="checkbox" />
          <span>Remember me</span>
        </label>

        <button type="button" className="adminAuth__forgot">
          Forgot Password?
        </button>
      </div>
    </>
  );
}

export default FormInputFields;
